<ng-content></ng-content>
@if (showSeparator) {
  <fa-icon class="text-sm" [icon]="separatorIcon"></fa-icon>
}
